import { combineReducers } from 'redux';
import produce from 'immer';
import { ActivityRunAction, ActivityRunActionType } from '../../actions/activityRunActions';
import { ActivityRunEvent } from '../../types/resources';

type BySeqNoState = {
  [seqNo: number]: ActivityRunEvent;
};

interface ByActivityRunIdState {
  byActivityRunId: Record<string, { bySeqNo: BySeqNoState }>;
}

export const initialState: ByActivityRunIdState = {
  byActivityRunId: {},
};

const byActivityRunId = (state = initialState.byActivityRunId, action: ActivityRunAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActivityRunActionType.GET_ACTIVITY_RUN_EVENTS: {
        draft[action.activityRunId] = { bySeqNo: {} };
        break;
      }
      case ActivityRunActionType.GET_ACTIVITY_RUN_EVENTS_OK: {
        action.data.forEach((event) => {
          draft[action.activityRunId].bySeqNo[event.seqNo] = event;
        });

        break;
      }
      case ActivityRunActionType.SET_ACTIVITY_RUN_EVENT: {
        action.events.forEach((event) => {
          if (draft[event.runId]) {
            draft[event.runId] = draft[event.runId] ? { ...draft[event.runId] } : { bySeqNo: {} };
            draft[event.runId].bySeqNo[event.seqNo] = event;
          }
        });
        break;
      }
      default:
        return state;
    }
  });

export default combineReducers({
  byActivityRunId,
});
